import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { router } from "./router.js";
import "./styles.css";
import { initAds, setAdFreeUntil } from "./lib/ads.js";
import { api } from "./lib/api.js";

// Ads: learn the ad-free state first so a rewarded user never sees a banner flash.
api
  .rewards()
  .then((r) => setAdFreeUntil(r.adFreeUntil))
  .catch(() => {})
  .finally(() => void initAds());

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
